let wxGzhTrolleyUserInfo = localStorage.getItem("wxGzhTrolleyUserInfo") || "{}";
const state = {
    userInfo: JSON.parse(wxGzhTrolleyUserInfo),
    appId: "wx4e3f4723475cf706", // 生产
    // appId: "wx645f528c1360a2fa", //测试
    imgPatch: './api/file/showImg?fileName='
}

const mutations = {
    SET_USERINFO: (state, userInfo) => {
        state.userInfo = userInfo
    },
}

const actions = {

}


export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js